import {
  isGroupedExportVariant,
  type DownloadSettingsModalVariant,
} from '@/app/(main)/client-detail/types/downloadSettingsModalVariant';
import type { UserExportSettingsInner } from '@/types/userExportSettingsApiTypes';
import type { ExportFormat, FormValues } from '../types';
import { formatToDocumentType } from './formatConverters';
import { loyaltyGranularAny, passportGranularAny } from './granularChecks';
import {
  mapAddressFromFormValues,
  mapBasicInformationFromFormValues,
  mapGroupViewExcludedFlags,
  mapImportantDatesFromFormValues,
  mapImportantTravelDataFromFormValues,
  mapTravelPreferencesByCategoryFromFormValues,
} from './sharedFormValueMapping';

export function buildExportSettingsPayload(
  values: FormValues,
  selectedFormat: ExportFormat,
  variant: DownloadSettingsModalVariant = 'default'
): UserExportSettingsInner {
  const isGroupView = isGroupedExportVariant(variant);
  const groupViewExcluded = mapGroupViewExcludedFlags(values, isGroupView);

  return {
    type: formatToDocumentType(selectedFormat),

    include_basic_information: mapBasicInformationFromFormValues(values, { includeHomeAirports: true }),
    include_address: mapAddressFromFormValues(values, { includeBilling: true }),
    include_allergies_dietary_restrictions: values.include_allergies_dietary_restrictions,
    include_loyalty_programs: values.include_loyalty_programs || loyaltyGranularAny(values),
    include_loyalty_program_full_name: values.include_loyalty_program_full_name,
    include_loyalty_program_program: values.include_loyalty_program_program,
    include_loyalty_program_number: values.include_loyalty_program_number,
    include_important_dates: mapImportantDatesFromFormValues(values),
    include_important_travel_data: mapImportantTravelDataFromFormValues(values),
    include_emergency_contact: groupViewExcluded.include_emergency_contact,
    include_flight_preferences: values.include_flight_preferences,
    include_travel_preferences_by_category: mapTravelPreferencesByCategoryFromFormValues(values, variant),
    include_related_contacts: groupViewExcluded.include_related_contacts,
    include_notes: groupViewExcluded.include_notes,
    include_tasks: groupViewExcluded.include_tasks,
    include_client_documents: groupViewExcluded.include_client_documents,
    include_passport_details:
      values.include_passport_details || passportGranularAny(values, { ignoreDocumentDob: isGroupView }),
    include_passport_details_passport_number: values.include_passport_details_passport_number,
    include_passport_details_document_date_of_birth: isGroupView
      ? false
      : values.include_passport_details_document_date_of_birth,
    include_passport_details_expiry_date: values.include_passport_details_expiry_date,
    include_comfort_related_full_name: values.include_comfort_related_full_name,
    include_comfort_related_height: values.include_comfort_related_height,
    include_comfort_related_weight: values.include_comfort_related_weight,
    include_comfort_related_details: values.include_comfort_related_details,
    include_passport_files_as_separate_pdfs: values.include_passport_files_as_separate_pdfs,
  };
}
